import loginType from "./loginType";

export const successLogin = (data) => ({
  type: loginType.SUCCESS_LOGIN,
  payload: data,
});
export const failureLogin = (data) => ({
  type: loginType.FAILURE_LOGIN,
  errorMessage: data[0].errorMessage,
  errorType: data[0].errorType,
});
